/**
 * PrimeReact 11's Button has no `icon` or `loading` props. This wrapper adds
 * both: an icon rendered before the label, and a loading state that shows a
 * spinner and blocks repeated clicks while a request is in flight.
 */
import type { ComponentProps } from "react";
import { Button as PrimeButton } from "@primereact/ui/button";

type PrimeButtonProps = ComponentProps<typeof PrimeButton>;

export type ButtonProps = PrimeButtonProps & {
  /** PrimeIcons class, e.g. "pi pi-plus". */
  icon?: string;
  loading?: boolean;
};

export function Button({
  icon,
  loading,
  disabled,
  children,
  iconOnly,
  ...rest
}: ButtonProps) {
  const hasLabel =
    children !== undefined && children !== null && children !== false;
  return (
    <PrimeButton
      {...(rest as PrimeButtonProps)}
      disabled={Boolean(disabled) || Boolean(loading)}
      aria-busy={loading ? true : undefined}
      iconOnly={iconOnly ?? (!hasLabel && Boolean(icon))}
    >
      {loading ? (
        <i className="pi pi-spin pi-spinner" aria-hidden="true" />
      ) : icon ? (
        <i className={icon} aria-hidden="true" />
      ) : null}
      {children}
    </PrimeButton>
  );
}
